import axios from '../utils/axios';

export default function getVerificationDocument(adminId, documentName, params) {
    return axios.get(`/admin/${adminId}/document/${documentName}`, { params });
};